export default __webpack_public_path__ + "static/media/telugu_health_m.7c58c97b.wav";